const firebaseNode = {
  CONNECTED_REF: '.info/connected',
  SERVER_TIME_OFFSET: '.info/serverTimeOffset',
  WEB_USERS_PRESENCE: 'webUsersPresence',
  WEB_USER_ROOM_NOTIFICATIONS: 'webUserNotifications',
  BROADCASTER_CONNECTION: 'broadcasterConnection',
  GUESTS_PRESENCE: 'guestPresence',
  CHATLESS_ROOM_USER_COUNT_LIGHT: 'uc',
  CHATLESS_GLOBAL_PRESENCE_SUBNODE: 'chatless',
  CHAT_ROOMS: 'chatRooms',
  ROOM_STATE: 'roomState',
  ROSTER: 'roster',
  CHAT_MESSAGES: 'chatMessages',
  PRIVATE_SHOW_REQUESTS: 'privateShowRequests',
  USER_NOTIFICATION: 'userNotification',
  BROADCASTING_STATUS: 'brp',
  EXTERNAL_ENCODER_STREAM_SYNC: 'externalEncoderStreamSync',
  FILTER_INFO: 'filterInfo',
};

export default firebaseNode;
